<div class="c-service-banner" [ngClass]="displayClass">
    <button class="c-service-banner__close c-ic-button" (click)="closeClicked($event)">
        <svg class="c-ic c-ic--sm  c-ic-dark"> <use xlink:href="#ic-close" href="#ic-close"></use></svg>
    </button>
    <div class="c-service-banner__text c-text-dark">
        <span class="c-text-bold">{{message.title}}</span>
        <div [innerHTML]="message.alertMessage" class="c-text-width c-text-dark"></div>
    </div>
</div>
